const getters = {
  loginState: state => state.app.loginState,
  webMode: state => state.website.seoSettings.mode //0:完整 ,1:簡易
};
export default getters;
